import { getUrlParameter } from './url-helper';

jQuery(($) => {
    function epiFilter ($dropdown, $selectBoxItem, $label, $nextDropdown, id) {
        const filter = document.getElementById(id);

        filter.addEventListener('change', e => {
            $(`select-${$dropdown}-dropdown`).removeClass('active');
            let url = window.location.href;
            const id = filter.value;

            if (getUrlParameter($dropdown)) {
                if (getUrlParameter($dropdown) === id) {

                } else {
                    url = url.replace(getUrlParameter($dropdown), id);
                    url = url.substring(0, url.indexOf(id) + 4);
                }
            } else {
                let splitter = '&';

                if (url.indexOf('?') > -1) {
                    splitter = '&';
                } else {
                    $dropdown === 'organisation-type' ? splitter = '?' : splitter = '&';
                }

                url = `${url + splitter + $dropdown}=${id}`;
            }

            $(filter).parents('.active').removeClass('active');

            $($label).text($(this).attr('data-title'));
            $nextDropdown === 'file' ? getFile(url, $nextDropdown) : getNextDropdown(url, $dropdown, $nextDropdown);
        });
    }

    function getFile (url, type) {
        $.ajax(url)
            .done((response) => {
                hideError();
                const obj = JSON.parse(response);
                $('.epi-file-link').remove();
                if (obj.File === 'True') {
                    const lastFilter = $('.epi-selector').last();
                    $(`<div class="epi-file-link columns is-multiline"><a class="button feedback-link column is-6-desktop is-12-mobile" href="${obj.Link}" target="_blank"  title="${obj.Title}"> <span class="text">Get Report</span><span class="icon"></span></a></div>`).insertAfter(lastFilter);
                }
                window.history.pushState(
                    { url },
                    document.title,
                    url
                );
                $('.select-filters-dropdown').removeClass('active');
            })
            .fail((xhr) => {
                showError(xhr);
            });
    }

    function getNextDropdown (url, currentDropdown, type) {
        $.ajax(url)
            .done((response) => {
                hideError();
                const objs = JSON.parse(response);
                const select = document.getElementById(`${type}-dropdown`);
                select.innerHTML = '' + `<option disabled selected hidden>Select ${type}</option>`;
                for (let i = 0; i < objs.length; i++) {
                    select.innerHTML = `${select.innerHTML}
                    <option class="select-box-${type}-item" value="${objs[i].ID}" data-title="${objs[i].Title}">${objs[i].Title}</option>`;
                }
                window.history.pushState(
                    { url },
                    document.title,
                    url
                );
                $('.epi-file-link').remove();
                isDropdownSetOption('organisation-type');
                isDropdownSetOption('organisation');
                isDropdownSetOption('year');
            })
            .fail((xhr) => {
                showError(xhr);
            });
    }

    function showError (xhr) {
        $('.select-filters-dropdown').removeClass('active');
        $('#epi-form-error-message').removeClass('is-hidden');
        console.log(`Error: ${xhr.responseText}`);
    }

    function hideError () {
        $('#epi-form-error-message').addClass('is-hidden');
    }

    function isDropdownSetOption (param) {
        const ID = getUrlParameter(param);
        if (ID) {
            $(`.select-a-${param}-label`).text($(`.select-box-${-param}-item[value='${ID}']`).attr('data-title'));
        } else {
            $('.select-filters-dropdown').removeClass('active');

            // if option is not year or organisation clear list under year
            if (param === 'organisation') {
                const select = document.getElementById('year-dropdown');
                select.innerHTML = '';
            }

            if (param === 'organisation' || param === 'organisation-type') {
                $(`.select-a-${param}-label`).text(`Select an ${param}`);
            } else {
                $(`.select-a-${param}-label`).text(`Select a ${param}`);
            }
        }
    }

    // If there is already a organisation type, organisation or year in the URL then activate the options in the dropdowns
    function setOptionsOnload ($param, $placeholder) {
        const ID = getUrlParameter($param);
        document.getElementById(`${$param}-dropdown`).value = ID || '';
    }

    epiFilter('organisation-type', '.select-box-organisation-type-item', '.select-a-organisation-type-label', 'organisation', 'organisation-type-dropdown');
    epiFilter('organisation', '.select-box-organisation-item', '.select-a-organisation-label', 'year', 'organisation-dropdown');
    epiFilter('year', '.select-box-year-item', '.select-a-year-label', 'file', 'year-dropdown');

    setOptionsOnload('organisation-type', 'Select an organisation type');
    setOptionsOnload('organisation', 'Select an organisation');
    setOptionsOnload('year', 'Select a year');
});



// WEBPACK FOOTER //
// ./src/js/app/epi-filter.js